/**
 * Converts an after-midnight time string (e.g. "24:02", "25:30") to its
 * clock-face equivalent (e.g. "00:02", "01:30") for display purposes.
 * Leaves times with hours 0–23 unchanged. Non-matching strings are returned as-is.
 */
export const displayTime = (time: string | undefined | null): string => {
    if (!time) return ''
    const match = time.match(/^(\d{1,2}):(\d{2})$/)
    if (!match) return time
    const hours = parseInt(match[1], 10)
    if (hours < 24) return time
    return `${String(hours % 24).padStart(2, '0')}:${match[2]}`
}
